import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { CtaButton } from './CtaButton';
function RevealBlock({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const ref = useScrollReveal<HTMLDivElement>();
  return <div ref={ref} className={`opacity-0 translate-y-10 transition-all duration-700 ease-out ${className}`} data-id="element-56">
      {children}
    </div>;
}
export function FinalCtaSection() {
  return <section className="py-20 px-5 text-center relative overflow-hidden" style={{
    background: 'linear-gradient(135deg, #2B4A42 0%, #1C352C 100%)'
  }} data-id="element-57">
      {/* Decorative circle */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(201, 168, 76, 0.06), transparent 60%)'
    }} data-id="element-58" />

      <div className="relative z-10" data-id="element-59">
        <RevealBlock data-id="element-60">
          <h2 className="font-display text-white mb-4" style={{
          fontSize: 'clamp(1.8rem, 4vw, 2.6rem)'
        }} data-id="element-61">
            Tu abdomen no es el problema.
            <br data-id="element-62" />
            Tu cortisol sí lo es. Y tiene solución.
          </h2>
        </RevealBlock>

        <RevealBlock data-id="element-63">
          <p className="text-white/75 text-[1.05rem] mb-10 max-w-[560px] mx-auto" data-id="element-64">
            Por $6.36 — menos de lo que cuesta un café con postre — tienes
            acceso al protocolo que tu cuerpo ha estado necesitando desde que
            tus hormonas cambiaron.
          </p>
        </RevealBlock>

        <RevealBlock data-id="element-65">
          <div data-id="element-66">
            <div className="inline-flex items-center gap-3 mb-4" data-id="element-67">
              <span className="text-base text-white/50 line-through font-medium" data-id="element-68">
                Valor real: $47.00
              </span>
              <span className="text-[2rem] font-bold text-oro font-display" data-id="element-69">
                $6.36
              </span>
              <span className="bg-rojo-urgencia text-white text-[0.7rem] font-bold py-1 px-2.5 rounded-full uppercase tracking-wider" data-id="element-70">
                HOY SOLO
              </span>
            </div>

            <div className="flex justify-center" data-id="element-71">
              <CtaButton href="https://simplementemejor.com/cart/51819834016024:1" ariaLabel="Obtener acceso inmediato al protocolo" className="max-w-[540px]" data-id="element-72">
                Quiero Recuperar Mi Metabolismo Ahora
              </CtaButton>
            </div>

            <div className="flex items-center justify-center gap-5 mt-4 flex-wrap" data-id="element-73">
              <span className="flex items-center gap-1.5 text-white/65 text-[0.78rem] font-medium" data-id="element-74">
                <span className="text-[0.9rem]" data-id="element-75">🔒</span> Pago Seguro
              </span>
              <span className="flex items-center gap-1.5 text-white/65 text-[0.78rem] font-medium" data-id="element-76">
                <span className="text-[0.9rem]" data-id="element-77">📱</span> Acceso Inmediato
              </span>
              <span className="flex items-center gap-1.5 text-white/65 text-[0.78rem] font-medium" data-id="element-78">
                <span className="text-[0.9rem]" data-id="element-79">🛡️</span> Garantía 7 días
              </span>
            </div>
          </div>
        </RevealBlock>
      </div>
    </section>;
}